function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF5F1",
  d: "M1440 83l-80-5.3c-80-5.7-240-15.7-400-32C800 30 640 8 480 3S160 8 80 13.7L0 19V0h1440v83z"
});

function SvgLogosBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 83"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDQwIDgzIj48ZGVmcy8+PHBhdGggZmlsbD0iI0ZGRjVGMSIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTQ0MCA4M2wtODAtNS4zYy04MC01LjctMjQwLTE1LjctNDAwLTMyQzgwMCAzMCA2NDAgOCA0ODAgM1MxNjAgOCA4MCAxMy43TDAgMTlWMGgxNDQwdjgzeiIvPjwvc3ZnPg==";
export { SvgLogosBottom as ReactComponent };